export default __webpack_public_path__ + "static/media/home_gif.cf7b16b1.gif";